import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCaseBasedScenario = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.06674 9.81323C8.27337 10.0414 8.56684 10.1715 8.87466 10.1715C9.18248 10.1715 9.47594 10.0414 9.68258 9.81323L10.2051 9.22989C10.5138 8.88853 11.0038 8.77825 11.429 8.95445C11.8541 9.13065 12.1225 9.55525 12.0992 10.0149L12.0601 10.7932C12.0427 11.1012 12.1575 11.402 12.3757 11.6201C12.5938 11.8383 12.8946 11.9531 13.2026 11.9357L13.9809 11.8966C14.4409 11.8727 14.866 12.1411 15.0422 12.5666C15.2183 12.9922 15.1073 13.4825 14.7651 13.7907L14.1867 14.3132C13.9581 14.5196 13.8276 14.8132 13.8276 15.1211C13.8276 15.4291 13.9581 15.7227 14.1867 15.9291L14.7651 16.4516C15.1073 16.7598 15.2183 17.2501 15.0422 17.6757C14.866 18.1012 14.4409 18.3696 13.9809 18.3457L13.2026 18.3066C12.8949 18.2906 12.595 18.4058 12.3771 18.6236C12.1593 18.8414 12.0441 19.1414 12.0601 19.4491L12.0992 20.2274C12.1225 20.687 11.8541 21.1116 11.429 21.2878C11.0038 21.464 10.5138 21.3538 10.2051 21.0124L9.68258 20.4291C9.47594 20.2009 9.18248 20.0707 8.87466 20.0707C8.56684 20.0707 8.27337 20.2009 8.06674 20.4291L7.54424 21.0124C7.23555 21.3538 6.74551 21.464 6.32034 21.2878C5.89518 21.1116 5.6268 20.687 5.65008 20.2274L5.68924 19.4491C5.70471 19.1416 5.58931 18.8419 5.37161 18.6242C5.1539 18.4065 4.85423 18.2911 4.54674 18.3066L3.76841 18.3457C3.30876 18.369 2.88417 18.1006 2.70797 17.6755C2.53176 17.2503 2.64205 16.7602 2.98341 16.4516L3.56258 15.9291C3.79073 15.7224 3.92089 15.429 3.92089 15.1211C3.92089 14.8133 3.79073 14.5199 3.56258 14.3132L2.98341 13.7907C2.64205 13.482 2.53176 12.992 2.70797 12.5668C2.88417 12.1417 3.30876 11.8733 3.76841 11.8966L4.54674 11.9357C4.85438 11.9517 5.15436 11.8365 5.37219 11.6187C5.59001 11.4008 5.70524 11.1009 5.68924 10.7932L5.65008 10.0149C5.6268 9.55525 5.89518 9.13065 6.32034 8.95445C6.74551 8.77825 7.23555 8.88853 7.54424 9.22989L8.06674 9.81323Z",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.87424 16.6882C9.73719 16.6882 10.4367 15.9887 10.4367 15.1257C10.4367 14.2628 9.73719 13.5632 8.87424 13.5632C8.0113 13.5632 7.31174 14.2628 7.31174 15.1257C7.31174 15.9887 8.0113 16.6882 8.87424 16.6882Z",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.5309 6.16656C17.3583 6.16656 17.2184 6.30647 17.2184 6.47906C17.2184 6.65165 17.3583 6.79156 17.5309 6.79156C17.7035 6.79156 17.8434 6.65165 17.8434 6.47906C17.8434 6.30647 17.7035 6.16656 17.5309 6.16656Z",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.6609 3.53989C19.8919 3.44995 20.1543 3.50506 20.3296 3.68037C20.5049 3.85567 20.56 4.11803 20.4701 4.34906L20.0534 5.42072C19.9545 5.67466 20.0317 5.96344 20.2442 6.13406L21.1401 6.85406C21.3332 7.00916 21.4166 7.26372 21.3525 7.50303C21.2884 7.74233 21.0891 7.92121 20.8442 7.95906L19.7084 8.13489C19.439 8.17608 19.2275 8.38726 19.1859 8.65656L19.0101 9.79322C18.9722 10.038 18.7934 10.2374 18.554 10.3015C18.3147 10.3655 18.0602 10.2822 17.9051 10.0891L17.1851 9.19322C17.0144 8.98087 16.7259 8.90336 16.4717 9.00156L15.4001 9.41822C15.169 9.50817 14.9067 9.45306 14.7314 9.27775C14.5561 9.10244 14.501 8.84009 14.5909 8.60906L15.0076 7.53739C15.1065 7.28345 15.0293 6.99467 14.8167 6.82406L13.9209 6.10322C13.7281 5.94824 13.645 5.69403 13.7091 5.4551C13.7732 5.21618 13.9723 5.03763 14.2167 4.99989L15.3526 4.82406C15.6219 4.78227 15.8333 4.57093 15.8751 4.30156L16.0509 3.16656C16.0884 2.92168 16.2671 2.72212 16.5064 2.65801C16.7457 2.5939 17.0002 2.67737 17.1551 2.87072L17.8759 3.76656C18.0467 3.97885 18.3353 4.05606 18.5892 3.95739L19.6609 3.53989Z",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgCaseBasedScenario);
export { ForwardRef as ReactComponent };
